// extracted by mini-css-extract-plugin
export default {"Spinner":"spinner__Spinner__LuRDS","spin":"spinner__spin__yhjlP"};